import {
  ProvinceSelectField,
  CitySelectField,
  DistrictSelectField,
  SubDistrictSelectField,
  InputField,
  CheckboxField
} from 'components'
import PropTypes from 'prop-types'
import React from 'react'
import { Row, Col } from 'reactstrap'

const currentValue = (value) => `Current Value: ${ value || '-' }`

const propTypes = {
  address     : PropTypes.object,
  formikProps : PropTypes.object
}

/**
 * some fields of User Address form
 * @param {object} address initial address
 * @param {object} formikProps formik props
 * @param {func} handleClickSetPinpoint function to show pinpoint component
 * @param {string} pinpointButtonText text of pinpoint button
 */

const UserAddressFields = ({
  address,
  formikProps
}) => {

  const getProvinceValue = (formikBag, provinceKey) => {
    const keys                     = provinceKey.split('.')
    const { values: formikValues } = formikBag
    let newValues                  = formikValues
    keys.map((k) => newValues = newValues[ k ])
    return newValues
  }

  const getSelectedOptionLabel = (e) => {
    const selectedIndex = e.target.selectedIndex
    const selectedLabel = e.target.options[selectedIndex].attributes.label.value

    return selectedLabel.toLowerCase()
  }

  const handleProvinceChange = (e) => {
    formikProps.handleChange(e)
    formikProps.setFieldValue('tl_city_id', -1)
    formikProps.setFieldValue('tl_district_id', -1)
    formikProps.setFieldValue('tl_sub_district_id', -1)
    formikProps.setFieldValue('postal_code', '')

    const provinceName = getSelectedOptionLabel(e)
    formikProps.setFieldValue('province', provinceName)
    formikProps.setFieldValue('city', '')
    formikProps.setFieldValue('district', '')
  }

  const handleCityChange = (e) => {
    formikProps.handleChange(e)
    formikProps.setFieldValue('tl_district_id', -1)
    formikProps.setFieldValue('tl_sub_district_id', -1)
    formikProps.setFieldValue('postal_code', '')

    const cityName = getSelectedOptionLabel(e)
    formikProps.setFieldValue('city', cityName)
    formikProps.setFieldValue('district', '')
  }

  const handleDistrictChange = (e) => {
    formikProps.handleChange(e)
    formikProps.setFieldValue('tl_sub_district_id', -1)
    formikProps.setFieldValue('postal_code', '')

    const districtName = getSelectedOptionLabel(e)
    formikProps.setFieldValue('district', districtName)
  }

  return (
    <Row>
      <Col md={ 6 }>
        <InputField
          type='text'
          name='street_address'
          label='Jalan'
          required={ true }
          formText={ currentValue(address.street_address) }
        />
        <ProvinceSelectField
          label='Provinsi'
          required={ true }
          name='tl_province_id'
          formText={ currentValue(address.province) }
          onChange={ handleProvinceChange }
        />
        <CitySelectField
          name='tl_city_id'
          label='Kota'
          required={ true }
          provinceValue = { getProvinceValue(formikProps,'tl_province_id') }
          formText={ currentValue(address.city) }
          onChange={ handleCityChange }
        />
        <DistrictSelectField
          name='tl_district_id'
          label='Kecamatan'
          required={ true }
          formikBag={ formikProps }
          provinceKey='tl_province_id'
          cityKey='tl_city_id'
          formText={ currentValue(address.district) }
          onChange={ handleDistrictChange }
        />
        <SubDistrictSelectField
          name='tl_sub_district_id'
          label='Kelurahan'
          required={ true }
          formikBag={ formikProps }
          provinceKey='tl_province_id'
          cityKey='tl_city_id'
          districtKey='tl_district_id'
          formText={ currentValue(address.sub_district) }
        />
        <InputField
          type='text'
          name='postal_code'
          label='Kode Pos'
          required={ true }
          formText={ currentValue(address.postal_code) }
        />
      </Col>
      <Col md={ 6 }>
        <InputField
          type='text'
          name='alias'
          label='Alias'
          required={ true }
          formText={ 'Contoh Kantor, Rumah, Apartemen' }
        />
        <InputField
          type='text'
          name='recipient_name'
          label='Recipient Name'
          formText={ 'Jika kosong maka `recipient name` akan otomatis mengikuti customer name' }
        />
        <InputField
          type='number'
          name='telephone'
          label='Telephone'
          formText={ 'jika kosong maka `telephone` akan otomatis mengikuti customer mobile number' }
        />
        <InputField
          type='text'
          name='note'
          label='Note'
          formText={ 'Contoh: Depan kantor pos, lantai 3' }
        />

        <CheckboxField
          name='is_customer_default'
          required={ false }
          label='Use as default shipping address'
        />
        <CheckboxField
          name='is_seller_default'
          required={ false }
          label='Use as default pickup address'
        />
      </Col>
    </Row>
  )
}

UserAddressFields.propTypes = propTypes

export default UserAddressFields
